import React from "react";

// Loacal imports
import PageLoader from "../global/page-loader";
import CTAStrip from "../global/cta.strip";

// Live imports
import { NavLink as Link, withRouter } from "react-router-dom";

function AboutBod() {
  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-heading">
                <h1>
                  Board Of <span>Directors</span>
                </h1>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclass="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/about-us" activeclass="active">
                          About
                        </Link>
                      </li>
                      <li>
                        <Link to="/about/bod" activeclass="active">
                          Board of Directors
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="inner-page-wrapper about-wrapper">
        <div className="container text-center about-bod">
          <div className="container">
            <div className="row">
              <div className="col mb-4">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/BOD_ALLAN_CERDAN.jpg"
                      width={299}
                      alt="BOD_ALLAN_CERDAN"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Allan Caido Cerdan</b>
                      </h5>
                      <p className="mb-0">Board Chairperson</p>
                      <p className="mb-0">District of Anda</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col mb-4"></div>
              <div className="col mb-4">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/GM_NAPOLEON_SEGUNDERA_JR.jpg"
                      width={299}
                      alt="GM_NAPOLEON_SEGUNDERA_JR"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Atty. Napoleon Flauta Segundera, Jr.</b>
                      </h5>
                      <p className="mb-0"> General Manager</p>
                      <p className="mb-0">PANELCO I</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              {/* end */}
              <div className="col mb-4">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/BOD_RONALD_ASTRONOMIA.jpg"
                      width="300"
                      alt="BOD_RONALD_ASTRONOMIA"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Ronald Miranda Astronomia</b>
                      </h5>
                      <p className="mb-0">Board Vice Chairperson</p>
                      <p className="mb-0">District of Alaminos</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col mb-4">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/BOD_LADYJEAN_JIMENEZ.jpg"
                      width={299}
                      alt="BOD_LADYJEAN_JIMENEZ"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Lady Jean Rivera Jimenez</b>
                      </h5>
                      <p className="mb-0">Board Secretary</p>
                      <p className="mb-0">District of Mabini</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col mb-4">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/BOD_MYRNA_CAASI.jpg"
                      width={299}
                      alt="BOD_MYRNA_CAASI"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Myrna Gementiza Caasi</b>
                      </h5>
                      <p className="mb-0">Board Treasurer</p>
                      <p className="mb-0">District of Bolinao</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col mb-4">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/BOD_CAMILLE_TOLENTINO.jpg"
                      width={299}
                      alt="BOD_CAMILLE_TOLENTINO"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Camille Guiang Tolentino</b>
                      </h5>
                      <p className="mb-0">Member of the Board</p>
                      <p className="mb-0">District of Burgos</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col mb-4">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/BOD_MARLYN_JUCAR.jpg"
                      width={299}
                      alt="BOD_MARLYN_JUCAR"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Marlyn Petalver Jucar</b>
                      </h5>
                      <p className="mb-0">Member of the Board</p>
                      <p className="mb-0">District of Bani</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col mb-4">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/BOD_MYRNA_CABANG.jpg"
                      width={299}
                      alt="BOD_MYRNA_CABANG"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Myrna Navalta Cabang</b>
                      </h5>
                      <p className="mb-0">Member of the Board</p>
                      <p className="mb-0">District of Dasol</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col mb-4 text-center">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/BOD_LOUIE_GINEZ.jpg"
                      width={299}
                      alt="BOD_LOUIE_GINEZ"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Louie Mores Ginez</b>
                      </h5>
                      <p className="mb-0">Member of the Board</p>
                      <p className="mb-0">District of Infanta</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col mb-4">
                <div className="bod">
                  <div className="card">
                    <img
                      src="/assets/images/about/BOD/BOD_ALVIN_NOVERO.jpg"
                      width={299}
                      alt="BOD_ALVIN_NOVERO"
                    />
                    <div className="container">
                      <h5 className="mb-0">
                        <b>Alvin Suarez Novero</b>
                      </h5>
                      <p className="mb-0">Member of the Board</p>
                      <p className="mb-0">District of Agno</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* end */}
            </div>
          </div>
        </div>
      </section>

      <CTAStrip />
    </>
  );
}

export default withRouter(AboutBod);
